'use client';

import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

export default function ViewMore({
  content,
  maxHeight = 96,
  fontSize = 16,
}: {
  content: string;
  maxHeight?: number;
  fontSize?: number;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setShowButton(contentRef.current.scrollHeight > maxHeight);
    }
  }, [content, maxHeight]);

  return (
    <div className="relative">
      {/* Full content for SEO (hidden from view) */}
      <div className="hidden">
        <p dangerouslySetInnerHTML={{ __html: content }} />
      </div>

      <div
        ref={contentRef}
        className={cn(
          'relative overflow-hidden transition-[max-height] duration-300 ease-in-out',
          !isExpanded && showButton && 'view-more-collapsed'
        )}
        style={{
          maxHeight: isExpanded ? 'none' : `${maxHeight}px`,
        }}
      >
        {!isExpanded && showButton && (
          <div
            className="absolute bottom-0 right-0 w-full h-[26px] pointer-events-none"
            style={{
              background: 'linear-gradient(0deg, white, transparent 80%)',
            }}
          />
        )}
        <p
          style={{ fontSize }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>

      {showButton && (
        <div className="text-right">
          <Button
            variant="ghost"
            className="text-primary"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'View less' : 'View more'}
          </Button>
        </div>
      )}
    </div>
  );
}
